import { SubProject } from 'src/app/model/project/sub-project';
import ClientAdminValue from '../../../display-model/client-admin-value';
import ProjectHelper from '../../../helpers/project-helper';

export enum EX_EDIT_ADJUSTMENT_KEY {
  STICKER_APPLIED_BY_CUSTOMER,
  EXTRA_INFO_ADJUSTMENT_PLACEHOLDER,
  USE_STANDARD_LAYOUT,
  ASSUME_ALL_COSTS_YES,
  ASSUME_ALL_COSTS_NO,
  REQUESTED_PLACEMENT_DATE
}

export const exEditAdjustmentStringsByName: Map<
  EX_EDIT_ADJUSTMENT_KEY,
  ClientAdminValue<string>
> = new Map<EX_EDIT_ADJUSTMENT_KEY, ClientAdminValue<string>>([
  [
    EX_EDIT_ADJUSTMENT_KEY.STICKER_APPLIED_BY_CUSTOMER,
    {
      clientValue: 'Sticker zelf aangebracht',
      adminValue: 'Sticker aangebracht door klant'
    }
  ],
  [
    EX_EDIT_ADJUSTMENT_KEY.EXTRA_INFO_ADJUSTMENT_PLACEHOLDER,
    {
      clientValue: 'Vul hier uw opmerkingen in',
      adminValue: (subProject: SubProject) => {
        return `Informatie over ${ProjectHelper.getFormDisplayArticle(
          subProject
        )} ${ProjectHelper.getFormDisplayNameLowerCase(subProject)}`;
      }
    }
  ],
  [
    EX_EDIT_ADJUSTMENT_KEY.USE_STANDARD_LAYOUT,
    {
      clientValue: 'Ik wens mijn standaard lay-out sticker te gebruiken',
      adminValue: 'Standaard lay-out sticker te gebruiken'
    }
  ],
  [
    EX_EDIT_ADJUSTMENT_KEY.ASSUME_ALL_COSTS_YES,
    {
      clientValue: (subProject: SubProject) => {
        return subProject.type === 'Repo'
          ? 'Mogelijke kosten worden gedeeld met de andere partijen'
          : 'Kosten worden gedeeld met de andere partijen';
      },
      adminValue: (subProject: SubProject) => {
        return subProject.type === 'Repo'
          ? 'Mogelijke kosten worden verdeeld onder alle partijen'
          : 'Kosten worden verdeeld onder alle partijen';
      }
    }
  ],
  [
    EX_EDIT_ADJUSTMENT_KEY.ASSUME_ALL_COSTS_NO,
    {
      clientValue: (subProject: SubProject) => {
        return `Ik neem alle kosten voor ${ProjectHelper.getFormDisplayArticle(
          subProject
        )} ${ProjectHelper.getFormDisplayNameLowerCase(subProject)} op mij`;
      },
      adminValue: (subProject: SubProject) => {
        return `Aanvrager neemt alle kosten voor ${ProjectHelper.getFormDisplayArticle(
          subProject
        )} ${ProjectHelper.getFormDisplayNameLowerCase(subProject)} op zich`;
      }
    }
  ],
  [
    EX_EDIT_ADJUSTMENT_KEY.REQUESTED_PLACEMENT_DATE,
    {
      clientValue: (subProject: SubProject) => {
        return subProject.type === 'Repo'
          ? 'Weghalingsdatum'
          : 'Plaatsingsdatum';
      },
      adminValue: (subProject: SubProject) => {
        return subProject.type === 'Repo'
          ? 'Gevraagde weghalingsdatum'
          : 'Gevraagde plaatsingsdatum';
      }
    }
  ]
]);
